export default "__VITE_ASSET__c0pzV2Hl__"